module.exports = __webpack_public_path__ + "static/img/share.57eefb50.png";